import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Observer from 'react-intersection-observer';
import Filter from '../Filter.js';
import ToggleableIcon from '../ToggleableIcon.js';
import Autocomplete from '../Autocomplete.js';
import { GAfireEvent } from '../Tracking'
import EnglishLink from '../EnglishLink.js';
import { isEs } from "../../libs/lang";
import {fireTag} from '../../libs/analytics.js';

const SearchForm = ({handleEvent, results, location, filterExpanded, showFilter, chooseDropdownType, checkForCityOrZip, mapLoading, alreadyShown, defaultCommunity}) => (
	<section className="search-controls">
		{
			!isEs() ?
				<>
					<form
						role="search"
						autoComplete="off"
						onSubmit={event => {
							event.preventDefault();
						}}
					>
						{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
						<label id="search-label" htmlFor="search-input">Find an organization near you</label>
						<Autocomplete
							orgResults={results.all}
							checkForCityOrZip={checkForCityOrZip}
							handleTextSearch={
								inputObj => {
									handleEvent({
										action: 'input',
										name: 'results',
										value: inputObj,
										origin: 'home'
									});
									handleEvent({
										action: 'search',
										type: 'input',
										name: 'results',
										origin: 'home'
									});
								}
							}
							route="home"
						/>
					</form>
				</> : 


		<form
			role="search"
			autoComplete="off"
			onSubmit={event => {
				event.preventDefault();
			}}
		>
			<label id="search-label" className="es" htmlFor="search-input">Encuentra una organización cerca de ti</label>
			<Autocomplete
				orgResults={results.all}
				checkForCityOrZip={checkForCityOrZip}
				handleTextSearch={
					inputObj => {
						handleEvent({
							action: 'input',
							name: 'results',
							value: inputObj,
							origin: 'home'
						});
						handleEvent({
							action: 'search',
							type: 'input',
							name: 'results',
							origin: 'home'
						});
					}}
				route="home"
			/>
		</form>
		}
		<div className={classNames('filter-controls', !mapLoading ? (showFilter ? 'cd-open more' : 'cd-open') : (alreadyShown ? 'cd-open' : ''))}>
			<p>
				{
					isEs() ?
						<>
							O filtra la búsqueda a nivel nacional por tipo de causa
						</> :
						<>
							Or filter nationally by cause type
						</>
				}
			</p>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
			<div
				className="filter-panel-dropdown"
				onClick={() => handleEvent({action: 'toggle', type: 'Filter', name: 'home', origin: 'home'})}
			>
				<button type="button" className={`toggle type full ${defaultCommunity ? 'has-default' : ''}`} aria-expanded={filterExpanded()}>
					{
						isEs() ?
							<>
								Selecciona una categoría
							</> :
							<>
								Select a category
							</>
					}
					<ToggleableIcon isUp={showFilter} className="indicator"/>
				</button>
				<Filter
					{...{location}}
					handleFilterClick={community => chooseDropdownType(community, 'home')}
					styles={classNames('menu-dropdown', {open: showFilter})}
					expanded={filterExpanded()}
					isDropdown
				/>
			</div>
		</div>
	</section>
)

const HomeMap = ({
					 uiState,
					 handleEvent,
					 resetMap,
					 chooseDropdownType,
					 mapLoading,
					 alreadyShown,
					 location,
					 results,
					 checkForCityOrZip,
					 enableScrollGA
				 }) => {

	const {showFilter, input} = uiState;
	const filterExpanded = () => !!showFilter;

	const containerRef = useRef(null)

	useEffect(() => {

	});

	let scrollHomepageMap = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(!window.location.href.includes('/sustainability/') && 
			!window.location.href.includes('/housing/') && !window.location.href.includes('/map/') 
			&& !scrollHomepageMap && document.querySelector('#find-local').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollHomepageMap = true;
				fireTag('S5');
			}
		});
	},[])

	return (
		<Observer
			tag='section'
			className="home-page map"
			id="find-local"
			ref={containerRef}
			triggerOnce
			threshold={0.50}
			onChange={inView => {
				if (inView && enableScrollGA) {
					//GAfireEvent('home_S5');
					//fireTag("S5");
				}
			}}
		>
			<div className='content-pillar'>
				<h2 tabIndex="-1" className="search-copy">

					{
						isEs() ?
							<>
								Mira lo que estamos haciendo para ayudar a comunidades en todo el país (en inglés)
							</> :
							<>
								See what we’re doing to help communities across the country
							</>
					}
				</h2>
				<div className='bar'/>
			</div>
			{/* MAP */}
			<div className="map-container">
				{
					isEs() ?
						<EnglishLink
							link={"/impact" + "/map/"}
							onclick={(e) => {
								//GAfireEvent('home_C19');
								fireTag('C16');
								resetMap();
							}}
						>
							<figure className="map-image" aria-label="Mapa de Estados Unidos con puntos que representan organizaciones que reciben ayuda de Wells Fargo."/>
						</EnglishLink>
						:
						<Link
							to="/map/"
							onClick={() => {
								//GAfireEvent('home_C19');
								fireTag('C16');
								resetMap();
							}}
						>
							<figure className="map-image" aria-label="Map of United States showing dots representing organizations helped by Wells Fargo."/>
						</Link>
				}
			</div>
			<div className="map-overlay">
				<SearchForm
					handleEvent={handleEvent}
					input={input}
					results={results}
					checkForCityOrZip={checkForCityOrZip}
					chooseDropdownType={chooseDropdownType}
					location={location}
					filterExpanded={filterExpanded}
					showFilter={showFilter}
					mapLoading={mapLoading}
					alreadyShown={alreadyShown}
					defaultCommunity={false}
				/>
			</div>
		</Observer>
	);
}

export default HomeMap;

